/**
 * CaseFlow+AI - Badge Component
 * Phase 5B: Light Mode + Design System Hardening
 */

import React from 'react';
import { toneColors } from '../../styles/themeTokens';

type BadgeTone = 'default' | 'green' | 'amber' | 'red' | 'blue' | 'purple';

interface BadgeProps {
  children: React.ReactNode;
  tone?: BadgeTone;
  className?: string;
}

export function Badge({ children, tone = 'default', className = '' }: BadgeProps) {
  return (
    <span className={`
      rounded-full px-3 py-1 text-xs font-medium
      ${toneColors[tone].light} ${toneColors[tone].dark}
      ${className}
    `}>
      {children}
    </span>
  );
}

export default Badge;
